// vue components
import TravelListItem from './vue/components/_travel-list-item.vue';

Vue.component('travel-list-item', TravelListItem);
